/**
 * =====================================
 * File: HeaderBar.js
 * Component: HeaderBar
 * Purpose: Create a page header for navigation among
 *  top-level pages
 * Author: Noah Fultz
 * Date: 2026-06-13
 * =====================================
 */


import { Link } from 'react-router-dom';
import './HeaderBar.css';

import { BlockButton, BarButton } from '../../components';


function HeaderBar({ access_level = 'PUBLIC' }) {
	return (<>
		{/* The banner type header of the app's page, all buttons are accessible */}
		<header id='headerbar-banner'>
			{/* This is the top row of the bar with the logo and link buttons */}
			<div id='headerbar-info-ctr'>

				{/* This is the leftmost section that contains the logo and troop name. This
					also links into the homepage */}
				<Link id='headerbar-logo-ctr' to='/' aria-label='BSA Troop 312 home page'>
					<img
						className='headerbar-bsa-logo'
						alt='BSA Logo'
						src='https://www.scouting.org/wp-content/uploads/2023/05/BSA_Logo.png'
					/>

					<span id='headerbar-bsat312-name'>BSA Troop 312 of Irmo</span>
				</Link>

				{/* The rightmost section that contains links to other websites */}
				<nav id='headerbar-extnav-ctr' aria-label='External resources'>
					<BlockButton type='external' href='https://my.scouting.org'>My Scouting</BlockButton>
					<BlockButton type='external' href='https://ecsssj.org/'>SSSJ Website</BlockButton>
				</nav>
			</div>

			{/* This is the lower row with internal navigation for public users */}
			{ access_level.toUpperCase() === 'PUBLIC' &&
				<nav aria-label='Main navigation' id='headerbar-nav-ctr'>
					<BarButton to='/'				 width='20%' height='100%'>Home</BarButton>
					<BarButton to='/about'	 width='20%' height='100%'>About Us</BarButton>
					<BarButton to='/join'		 width='20%' height='100%'>Join Us</BarButton>
					<BarButton to='/contact' width='20%' height='100%'>Contact Us</BarButton>
					<BarButton to='/login'   width='20%' height='100%'>Log In</BarButton>
				</nav>
			}
		</header>

		{/* The collapseable type header that allows buttons to be expanded */}
		<header id='headerbar-expandable'>
			<Link id='headerbar-logo-ctr' to='/' aria-label='BSA Troop 312 home page'>
				<img
					className='headerbar-bsa-logo'
					alt='BSA Logo'
					src='https://www.scouting.org/wp-content/uploads/2023/05/BSA_Logo.png'
				/>
			</Link>

			{/* This is the set of bars on the right side of the menu bar */}
			<label htmlFor='headerbar-collapse-innerbtn' id='headerbar-collapse-btn'>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 640 640">
					{/* !Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com
							License - https://fontawesome.com/license/free
							Copyright 2026 Fonticons, Inc. */}
					<path
						d="M96 160C96 142.3 110.3 128 128 128L512 128C529.7
						128 544 142.3 544 160C544 177.7 529.7 192 512 192L128
						192C110.3 192 96 177.7 96 160zM96 320C96 302.3 110.3
						288 128 288L512 288C529.7 288 544 302.3 544 320C544
						337.7 529.7 352 512 352L128 352C110.3 352 96 337.7 96
						320zM544 480C544 497.7 529.7 512 512 512L128 512C110.3
						512 96 497.7 96 480C96 462.3 110.3 448 128 448L512
						448C529.7 448 544 462.3 544 480z"
					/>
				</svg>

				<button
					style={{ display: 'none' }}
					id='headerbar-collapse-innerbtn'
					onClick={() => {
						document.getElementById('headerbar-collapse-navctr')
							.style.width = '250px';
					}}
				/>
			</label>

			{/* This is the collapseable menu that opens/closes with navigation buttons */}
			<div id='headerbar-collapse-navctr'>
				{/* This is the arrow that triggers the menu to collapse */}
				<label htmlFor='headerbar-return-innerbtn' id='headerbar-return-btn'>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 640 640">
						{/* !Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com
								License - https://fontawesome.com/license/free
								Copyright 2026 Fonticons, Inc. */}
						<path
							d="M566.6 342.6C579.1 330.1 579.1 309.8 566.6 297.3L406.6
							137.3C394.1 124.8 373.8 124.8 361.3 137.3C348.8 149.8 348.8
							170.1 361.3 182.6L466.7 288L96 288C78.3 288 64 302.3 64 320C64
							337.7 78.3 352 96 352L466.7 352L361.3 457.4C348.8 469.9 348.8
							490.2 361.3 502.7C373.8 515.2 394.1 515.2 406.6 502.7L566.6 342.7z"
						/>
					</svg>

					<button
						style={{ display: 'none' }}
						id='headerbar-return-innerbtn'
						onClick={() => {
							document.getElementById('headerbar-collapse-navctr')
								.style.width = '0vw';
						}}
					/>
				</label>

				{/* These are the links to the publicly accessible pages */}
				{ access_level.toUpperCase() === 'PUBLIC' && (<>
					<BarButton to='/' width='100%' height='50px'
						onClick={() => {
							document.getElementById('headerbar-collapse-navctr')
								.style.width = '0vw';
						}}>Home</BarButton>

					<BarButton to='/about' width='100%' height='50px'
						onClick={() => {
							document.getElementById('headerbar-collapse-navctr')
								.style.width = '0vw';
						}}>About Us</BarButton>

					<BarButton to='/join' width='100%' height='50px'
						onClick={() => {
							document.getElementById('headerbar-collapse-navctr')
								.style.width = '0vw';
						}}>Join Us</BarButton>

					<BarButton to='/contact' width='100%' height='50px'
						onClick={() => {
							document.getElementById('headerbar-collapse-navctr')
								.style.width = '0vw';
						}}>Contact Us</BarButton>

					<BarButton to='/login' width='100%' height='50px'
						onClick={() => {
							document.getElementById('headerbar-collapse-navctr')
								.style.width = '0vw';
						}}>Log In</BarButton>
				</>) }
			</div>
		</header>
	</>);
}


export default HeaderBar;